import { apiClient } from "@/services/api.client"

/**
 * Read a compiled-OIO draft text blob through the authenticated backend proxy
 * (nitiassist → oio, which reads GCS with the service account).
 *
 * The artifact object is PRIVATE in GCS, so the browser CANNOT fetch the
 * artifactBlobUrl directly — a plain `fetch(blobUrl)` returns 403. This is the
 * only reliable way for a client with no cached draft (a true reconnect after
 * close/sleep) to load the finished order.
 */
export async function readDraftText(blobUrl: string): Promise<string> {
  const { text } = await apiClient.post<{ text: string }>("/api/v1/storage/read_text", {
    blob_url: blobUrl,
  })
  return text ?? ""
}

/**
 * Write the officer's own edit of the draft back to its blob, through the same
 * authenticated proxy (the gateway checks the blob is this user's before it
 * forwards the overwrite).
 */
export async function overwriteDraftText(blobUrl: string, text: string): Promise<void> {
  await apiClient.post("/api/v1/storage/overwrite_text", { blob_url: blobUrl, text })
}

/**
 * Marks the start of a true new attempt for a given agent/thread pair so other
 * tabs can clear stale progress only when a fresh run is intentionally started.
 */
export async function markNewAttempt(agentName: string, threadId: string): Promise<void> {
  await apiClient.post(`/api/v1/storage/runs/${agentName}/${threadId}/new-attempt`)
}
